"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPromoCodeToList = void 0;
const utils_1 = require("../../../utils");
const buildPath = (shoppingListId) => `/v1/bff/appro/shopping-lists/${shoppingListId}/promo-codes`;
const addPromoCodeToList = (client) => async ({ shoppingListId, ...body }) => {
    try {
        const { data } = await client.post(buildPath(shoppingListId), body);
        return { shoppingList: data };
    }
    catch (error) {
        if ((0, utils_1.isFunctionalApiError)(error)) {
            return {
                error: {
                    code: error.body.code,
                    message: error.body.message
                }
            };
        }
        throw error;
    }
};
exports.addPromoCodeToList = addPromoCodeToList;
